import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PublicLayout } from '../../components/layout';

const FAQ: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<
    'all' | 'account' | 'billing' | 'technical' | 'features'
  >('all');
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const categories = [
    { key: 'all', label: 'جميع الأسئلة', icon: '❓' },
    { key: 'account', label: 'الحساب والتسجيل', icon: '👤' },
    { key: 'billing', label: 'الفوترة والاشتراكات', icon: '💳' },
    { key: 'technical', label: 'المشاكل التقنية', icon: '🔧' },
    { key: 'features', label: 'الميزات والاستخدام', icon: '⚡' },
  ];

  const faqs = [
    {
      id: 1,
      category: 'account',
      question: 'كيف يمكنني إنشاء حساب جديد؟',
      answer:
        'يمكنك إنشاء حساب جديد عن طريق النقر على زر "التسجيل" في الصفحة الرئيسية، ثم ملء النموذج المطلوب بالمعلومات الأساسية مثل الاسم، البريد الإلكتروني، ورقم الهاتف. بعد التسجيل، ستتلقى رسالة تأكيد عبر البريد الإلكتروني.',
      popular: true,
    },
    {
      id: 2,
      category: 'account',
      question: 'نسيت كلمة المرور، كيف يمكنني استعادتها؟',
      answer:
        'انقر على رابط "نسيت كلمة المرور" في صفحة تسجيل الدخول، ثم أدخل بريدك الإلكتروني. ستتلقى رسالة تحتوي على رابط لإعادة تعيين كلمة المرور. الرابط صالح لمدة 30 دقيقة.',
      popular: true,
    },
    {
      id: 3,
      category: 'billing',
      question: 'ما هي طرق الدفع المتاحة؟',
      answer:
        'جميع المدفوعات آمنة ومحمية ببروتوكول تشفير SSL عبر موفري خدمات الدفع المعتمدين.',
      popular: true,
    },
    {
      id: 4,
      category: 'billing',
      question: 'هل يمكنني تغيير خطتي في أي وقت؟',
      answer:
        'نعم، يمكنك الترقية أو التراجع عن خطتك في أي وقت من خلال إعدادات الحساب. عند الترقية، ستحصل على الميزات الجديدة فوراً ويتم احتساب الفرق في التكلفة. عند التراجع، ستظل الخطة الحالية نشطة حتى نهاية دورة الفوترة.',
      popular: false,
    },
    {
      id: 5,
      category: 'billing',
      question: 'هل تقدمون ضمان استرداد الأموال؟',
      answer:
        'يمكنك طلب استرجاع مبلغ الاشتراك خلال 7 أيام من تاريخ الدفع إذا لم يتم استخدام الميزات المدفوعة بشكل جوهري أو لم يبدأ تقديم الخدمة المرتبطة بالاشتراك. لا يشمل الاسترجاع رسوم مزود الدفع أو البنك إلا إذا تم ردها فعليًا، وتتم مراجعة الطلب خلال 5 إلى 10 أيام عمل.',
      popular: false,
    },
    {
      id: 6,
      category: 'technical',
      question: 'لا يمكنني الوصول للمنصة، ما الحل؟',
      answer:
        'أولاً، تأكد من اتصالك بالإنترنت. ثم جرب تحديث الصفحة أو استخدام متصفح مختلف. إذا استمرت المشكلة، امسح ذاكرة التخزين المؤقت وملفات تعريف الارتباط. يمكنك أيضاً تجربة الوصول من جهاز آخر.',
      popular: true,
    },
    {
      id: 7,
      category: 'technical',
      question: 'مشكلة في جودة الصوت والفيديو في الفصول الافتراضية',
      answer:
        'تأكد من سرعة الإنترنت (ننصح بـ 10 ميجابت على الأقل). أغلق التطبيقات الأخرى التي تستهلك الإنترنت. تحقق من إعدادات الكاميرا والمايكروفون في المتصفح. استخدم سماعات بدلاً من مكبرات الصوت لتجنب الصدى.',
      popular: false,
    },
    {
      id: 8,
      category: 'technical',
      question: 'التطبيق يعمل ببطء، كيف يمكن تحسين الأداء؟',
      answer:
        'امسح ذاكرة التخزين المؤقت للمتصفح، أعد تشغيل المتصفح، تأكد من أن لديك آخر إصدار من المتصفح، أغلق علامات التبويب غير المستخدمة، وتأكد من أن جهازك يلبي الحد الأدنى من المتطلبات التقنية.',
      popular: false,
    },
    {
      id: 9,
      category: 'features',
      question: 'كيف يمكنني جدولة حصة جديدة؟',
      answer:
        'انتقل إلى قسم "الجدولة" من لوحة التحكم، انقر على "حصة جديدة"، اختر التاريخ والوقت، حدد الطلاب المشاركين، أضف عنوان ووصف للحصة، ثم احفظ. سيتم إرسال دعوات تلقائياً للطلاب.',
      popular: true,
    },
    {
      id: 10,
      category: 'features',
      question: 'كيف أتابع حضور الطلاب؟',
      answer:
        'يمكنك مراقبة الحضور من خلال تقارير الحضور في لوحة التحكم. كما يمكنك تسجيل الحضور يدوياً أثناء الحصة أو تفعيل التسجيل التلقائي. ستتلقى تقارير أسبوعية بحضور كل طالب.',
      popular: false,
    },
    {
      id: 11,
      category: 'features',
      question: 'كيف أنشئ واجب منزلي للطلاب؟',
      answer:
        'اذهب إلى قسم "الواجبات"، انقر على "واجب جديد"، أدخل عنوان الواجب والتعليمات، حدد تاريخ التسليم، أضف أي مرفقات مطلوبة، اختر الطلاب، ثم انشر الواجب. سيتلقى الطلاب إشعاراً فورياً.',
      popular: true,
    },
    {
      id: 12,
      category: 'features',
      question: 'هل يمكنني تسجيل الحصص؟',
      answer:
        'نعم، يمكنك تسجيل الحصص الافتراضية تلقائياً. فعّل خيار التسجيل قبل بدء الحصة، وسيتم حفظ التسجيل في مكتبة التسجيلات. يمكن للطلاب الوصول للتسجيلات لاحقاً للمراجعة.',
      popular: false,
    },
  ];

  const filteredFaqs = faqs.filter(faq => {
    const matchesCategory =
      selectedCategory === 'all' || faq.category === selectedCategory;
    const matchesSearch =
      searchQuery === '' ||
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesCategory && matchesSearch;
  });

  const popularFaqs = faqs.filter(faq => faq.popular);

  const toggleFaq = (id: number) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  return (
    <PublicLayout>
      <div className='bg-gradient-to-br from-primary-50 to-secondary-50'>
        {/* Hero Section */}
        <div className='bg-gradient-to-r from-primary-600 to-primary-800 text-white py-20'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
            <div className='text-center'>
              <h1 className='text-4xl md:text-6xl font-bold mb-6'>
                الأسئلة الشائعة
              </h1>
              <p className='text-xl md:text-2xl text-primary-100 max-w-3xl mx-auto mb-8'>
                ابحث عن إجابات سريعة لأكثر الأسئلة شيوعاً حول Class-Tech
              </p>

              {/* Search Bar */}
              <div className='max-w-2xl mx-auto'>
                <div className='relative'>
                  <input
                    type='text'
                    placeholder='ابحث في الأسئلة الشائعة...'
                    value={searchQuery}
                    onChange={e => setSearchQuery(e.target.value)}
                    className='w-full px-6 py-4 pr-12 rounded-lg text-secondary-900 placeholder-secondary-500 focus:outline-none focus:ring-2 focus:ring-white'
                  />
                  <div className='absolute left-4 top-1/2 transform -translate-y-1/2'>
                    <span className='text-secondary-400'>🔍</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16'>
          {/* Popular FAQs */}
          {searchQuery === '' && selectedCategory === 'all' && (
            <div className='mb-16'>
              <h2 className='text-3xl font-bold text-secondary-900 mb-8 text-center'>
                الأسئلة الأكثر شيوعاً
              </h2>
              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
                {popularFaqs.map(faq => (
                  <div
                    key={faq.id}
                    className='bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow p-6 cursor-pointer'
                    onClick={() => toggleFaq(faq.id)}
                  >
                    <h3 className='font-semibold text-secondary-900 mb-2 line-clamp-2'>
                      {faq.question}
                    </h3>
                    <p className='text-sm text-secondary-600 line-clamp-3'>
                      {faq.answer}
                    </p>
                    <div className='mt-4 text-primary-600 text-sm font-medium'>
                      اقرأ المزيد ←
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className='flex flex-col lg:flex-row gap-8'>
            {/* Categories Sidebar */}
            <div className='lg:w-1/4'>
              <div className='bg-white rounded-lg shadow-sm p-6 sticky top-6'>
                <h3 className='font-semibold text-secondary-900 mb-4'>
                  التصنيفات
                </h3>
                <div className='space-y-2'>
                  {categories.map(category => (
                    <button
                      key={category.key}
                      onClick={() => setSelectedCategory(category.key as any)}
                      className={`w-full text-right px-4 py-3 rounded-lg transition-colors ${selectedCategory === category.key
                          ? 'bg-primary-100 text-primary-700 border border-primary-200'
                          : 'hover:bg-secondary-50 text-secondary-700'
                        }`}
                    >
                      <div className='flex items-center'>
                        <span className='ml-3'>{category.icon}</span>
                        <span>{category.label}</span>
                        <span className='mr-auto bg-secondary-100 text-secondary-600 text-xs px-2 py-1 rounded-full'>
                          {
                            faqs.filter(
                              f =>
                                category.key === 'all' ||
                                f.category === category.key
                            ).length
                          }
                        </span>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* FAQ List */}
            <div className='lg:w-3/4'>
              <div className='bg-white rounded-lg shadow-sm'>
                <div className='p-6 border-b border-secondary-200'>
                  <h2 className='text-2xl font-bold text-secondary-900'>
                    {searchQuery
                      ? `نتائج البحث: "${searchQuery}"`
                      : selectedCategory === 'all'
                        ? 'جميع الأسئلة'
                        : categories.find(c => c.key === selectedCategory)?.label}
                  </h2>
                  <p className='text-secondary-600 mt-2'>
                    {filteredFaqs.length} سؤال متاح
                  </p>
                </div>

                <div className='divide-y divide-secondary-200'>
                  {filteredFaqs.map(faq => (
                    <div key={faq.id} className='p-6'>
                      <button
                        onClick={() => toggleFaq(faq.id)}
                        className='w-full text-right flex items-center justify-between hover:text-primary-600 transition-colors'
                      >
                        <h3 className='text-lg font-semibold text-secondary-900 flex-1'>
                          {faq.question}
                        </h3>
                        <div className='mr-4 flex items-center'>
                          {faq.popular && (
                            <span className='bg-primary-100 text-primary-700 text-xs px-2 py-1 rounded-full ml-2'>
                              شائع
                            </span>
                          )}
                          <span
                            className={`transform transition-transform ${openFaq === faq.id ? 'rotate-180' : ''
                              }`}
                          >
                            ↓
                          </span>
                        </div>
                      </button>

                      {openFaq === faq.id && (
                        <div className='mt-4 text-secondary-700 leading-relaxed'>
                          {faq.answer}
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {filteredFaqs.length === 0 && (
                  <div className='p-12 text-center'>
                    <div className='text-4xl mb-4'>🤔</div>
                    <h3 className='text-lg font-semibold text-secondary-900 mb-2'>
                      لم نجد أسئلة مطابقة
                    </h3>
                    <p className='text-secondary-600 mb-6'>
                      جرب البحث بكلمات أخرى أو تصفح تصنيف مختلف
                    </p>
                    <Link
                      to='/contact#contact-form'
                      className='inline-flex bg-primary-600 hover:bg-primary-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors'
                    >
                      تواصل مع الدعم
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Help Section */}
        <div className='bg-white py-16'>
          <div className='max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center'>
            <h2 className='text-3xl font-bold text-secondary-900 mb-4'>
              لم تجد إجابة لسؤالك؟
            </h2>
            <p className='text-lg text-secondary-600 mb-8'>
              فريق الدعم متاح لمساعدتك في أي وقت
            </p>
            <div className='flex flex-col sm:flex-row gap-4 justify-center'>
              <Link
                to='/contact#contact-form'
                className='bg-primary-600 hover:bg-primary-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors'
              >
                تواصل مع الدعم
              </Link>
              <Link
                to='/contact#contact-form'
                className='border border-secondary-300 text-secondary-700 hover:bg-secondary-50 px-8 py-3 rounded-lg font-semibold transition-colors'
              >
                إرسال اقتراح
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default FAQ;
